import { NgModule } from '@angular/core';

import { PatientEvaluationApiService } from './patient-evaluation.service';

@NgModule({
    providers: [PatientEvaluationApiService],
})
export class PatientEvaluationApiModule {}

